import Form from '../_form';

export default class PersonalInfoForm extends Form {

    /* eslint-disable no-useless-constructor */
    constructor (query) {
        super(query);
    }

    simulateNameUpdate (firstName, lastName) {
        const header = document.querySelector('.site-header--profile-navigation-name');
        const headerMobile = document.querySelector('.site-header--profile-name');
        const aside = document.querySelector('.site-dashboard--user-data h2');

        const name = `${firstName} ${lastName}`;

        if (header) header.textContent = name;
        if (headerMobile) headerMobile.textContent = name;
        if (aside) aside.textContent = name;
    }

    async finalizeForm () {
        if (this.submit) this.submit.classList.add('preload');

        const formData = new FormData(this.form);

        const firstName = formData.get('firstname');
        const lastName = formData.get('lastname');
        const occupation = formData.get('occupation');
        const location = formData.get('location');
        const about = formData.get('about');
        const phone = formData.get('phone');

        try {
            await fetch('/wp-json/user/v1/personal-info', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ firstName, lastName, occupation, location, about, phone })
            })
            .then((response) => response.json())
            .then((data) => {
                if (data && !data.error) {
                    this.form.classList.remove('error');
                    this.form.classList.add('sent');

                    this.NotificationManager.sendNotification('success', 'Successfully updated!', data.message);

                    if (this.submit) this.submit.classList.remove('preload');

                    this.simulateNameUpdate(firstName, lastName);
                } else {
                    this.NotificationManager.sendNotification('error', 'An error occurred...', data.message);

                    if (this.submit) this.submit.classList.remove('preload');

                    this.form.classList.add('error');
                }
            })
            .catch(() => {
                this.NotificationManager.sendNotification('error', 'An error occurred...', 'Please, try again');

                if (this.submit) this.submit.classList.remove('preload');

                this.form.classList.add('error');
            });
        } catch (error) {
            this.NotificationManager.sendNotification('error', 'An error occurred...', 'Please, try again');

            if (this.submit) this.submit.classList.remove('preload');

            this.form.classList.add('error');
        }
    }
}
